/* eslint-disable jsx-a11y/mouse-events-have-key-events */

import type React from 'react';
import styled, { css, type DefaultTheme } from 'styled-components';

const RANDOM_OPACITIES = [0.25, 0.3, 0.4];

const highlightedStyle = (theme: DefaultTheme) => css`
  fill: ${theme.colors.primary};
  cursor: pointer;

  &:hover {
    fill: ${theme.colors.darkerPrimary};
  }
`;

const StyledGroup = styled.g<{ highlighted: boolean }>`
  fill: ${({ theme }) => theme.colors.metal};
  user-select: none;
  ${({ highlighted, theme }) => highlighted && highlightedStyle(theme)}
`;

const StyledPolygon = styled.polygon`
  stroke: ${({ theme }) => theme.colors.white};
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
  user-select: none;
`;

interface MapGroupProps {
  code: string;
  highlighted: boolean;
  onMouseIn: (ev: React.MouseEvent) => void;
  onMouseOut: (ev: React.MouseEvent) => void;
}

export const MapGroup: React.FC<React.PropsWithChildren<MapGroupProps>> = ({
  code,
  highlighted,
  onMouseIn,
  onMouseOut,
  children,
}) => {
  const opacitySeed = code.charCodeAt(0) + code.charCodeAt(1);
  const opacity = highlighted ? 1 : RANDOM_OPACITIES[opacitySeed % RANDOM_OPACITIES.length];
  return (
    <StyledGroup
      opacity={opacity}
      className={code}
      highlighted={highlighted}
      onMouseEnter={ev => highlighted && onMouseIn(ev)}
      onMouseOut={ev => highlighted && onMouseOut(ev)}
    >
      {children}
    </StyledGroup>
  );
};

interface MapPolygonProps {
  points: string;
}

export const MapPolygon: React.FC<MapPolygonProps> = ({ points }) => {
  const el: 'path' | 'polygon' = points[0] === 'M' ? 'path' : 'polygon';
  const pointsAttr = el === 'path' ? 'd' : 'points';
  return <StyledPolygon {...{ [pointsAttr]: points }} as={el} />;
};
